import React from "react";

function CommitteesIcon(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="38"
      height="38"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      {...props}
    >
      <circle cx="8" cy="7" r="3" />
      <circle cx="17" cy="8" r="2.5" />
      <path d="M2 21v-1a6 6 0 0 1 6-6 6 6 0 0 1 6 6v1" />
      <path d="M15.5 14a5 5 0 0 1 4.5 5v1" />
    </svg>
  );
}

export default CommitteesIcon;
